<section>
  <button type="button" class="close" (click)="close()">
    <i class="fa-solid fa-xmark"></i>
  </button>
  <h1 translate>components.reserva.¡Hola! Valida tu email</h1>
  <p translate>components.reserva.Para poder ingresar al área</p>
  <p class="link">
    {{ credentialsService?.credentials?.email }}
  </p>
  <span translate> components.reserva.Si no lo ves </span>
  <span
    translate
    class="link"
    style="cursor: pointer"
    (click)="reSendEmailVerification()"
  >
    components.reserva.O haz clic aquí
  </span>
  <br />
  <p class="separate" *ngIf="reSendEmail" translate>
    components.oferta.Email enviado correctamente.
  </p>
</section>
